import React from 'react'
import './extras12.css'

function Extras12() {
    return (
        <div className='extra-container'>
            <div>
                <h1 className='h1-extras'>
                    Supplementary Material
                </h1>
            </div>
            <div className='sample-paper-board'>
                <h2 className='h2-extras'>
                    Question Papers CBSE board
                </h2>
                <li>
                    <a href='http://cbseacademic.nic.in/web_material/SQP/ClassXII_2020_21/Physics-SQP.pdf'>Physics paper</a>
                </li>
                <li>
                    <a href='http://cbseacademic.nic.in/web_material/SQP/ClassXII_2020_21/Chemistry-SQP.pdf'>Chemistry paper</a>

                </li>
                <li>
                    <a href='http://cbseacademic.nic.in/web_material/SQP/ClassXII_2020_21/Maths-SQP.pdf'>Maths Paper</a>
                </li>
                <li>
                    <a href='http://cbseacademic.nic.in/SQP_CLASSXII_2020-21.html'>anyother paper or answer scheme</a>
                </li>

            </div>
            <div className='list-of-exams'>
                <h2 className='h2-extras'>
                    Important Entrance Exams
                </h2>
                <li>
                    <a href='https://testservices.nic.in/examSys21/root/Home.aspx?enc=Ei4cajBkK1gZSfgr53ImFVj34FesvYg1WX45sPjGXBoodsCAPgItCPvwv6bGBGio'>JEE Mains Application</a>
                </li>
                <li>
                    <a href='https://www.bitsadmission.com/'>BITSAT application</a>
                </li>
                <li>
                    <a href='https://viteee.vit.ac.in/'>VITEEE application</a>
                </li>
                <li>
                    <a href='https://apply.manipal.edu/'>Manipl Entrance Test application form</a>
                </li>
                <li>
                    <a href='https://cetcell.mahacet.org/'>MahaCET</a>
                </li>
            </div>
            
        </div>
    )
}

export default Extras12
